<div id="date-overlay" class="date-overlay" (click)="closeOverlay()"></div>